import { createSlice } from '@reduxjs/toolkit';

import { IconDrawerState } from './types';

// The initial state of the ShoppingCart container
export const drawerInitialState: IconDrawerState = {
  open: false
};

const iconDrawerSlice = createSlice({
  name: 'iconDrawer',
  initialState: drawerInitialState,
  reducers: {
    close(state) {
      state.open = false;
    },
    open(state) {
      state.open = true;
    }
  }
});

export const {
  actions: IconDrawerActions,
  reducer: iconDrawerReducer,
  name: drawerSliceKey
} = iconDrawerSlice;
